import { colorConstants } from 'config/colorConstants';
import { CategoryMovementOutputChartItem } from 'types/pricingSimulator';

export const categoryMovementChartParser = (chartConfig: any[], data: any[][]) => {
    try {
        const result = data?.map((graphItem, index) => {
            const configItem = chartConfig?.[index];
            let minVal = 0;
            let maxVal = 0;
            const parsedGraphItem = graphItem?.map((item: any) => {
                minVal = Math.min(minVal, item?.value);
                maxVal = Math.max(maxVal, item?.value);
                return {
                    featureName: item?.feature_name,
                    category: item?.label_name,
                    sales: item?.value,
                    labelSales: item?.value,
                    color: Number(item?.value) < 0 ? colorConstants.red : colorConstants.limeGreen,
                };
            });
            let outputObj: CategoryMovementOutputChartItem = {
                data: parsedGraphItem,
                labelObject: {
                    mainLabel: configItem?.label,
                    xAxis: configItem?.xAxisLabel,
                    yAxis: configItem?.yAxisLabel,
                },
                id: configItem?.value,
                maxVal,
                minVal,
            };
            return outputObj;
        });
        return result;
    } catch (error) {
        throw error;
    }
};

export const categoryMovementByLevelChartParser = (graphObj: any, count: number, data: any[]) => {
    try {
        let minVal = 0;
        let maxVal = 0;
        const result = data?.map((item: any) => {
            minVal = Math.min(minVal, item?.value);
            maxVal = Math.max(maxVal, item?.value);
            return {
                category: item?.attribute_name,
                sales: item?.value,
                labelSales: item?.value,
                color: Number(item?.value) < 0 ? colorConstants.red : colorConstants.limeGreen,
            };
        });
        let outputObj: CategoryMovementOutputChartItem = {
            count: count ?? 0,
            data: result,
            id: graphObj?.value,
            maxVal,
            minVal,
            labelObject: {
                mainLabel: graphObj?.label,
                xAxis: graphObj?.xAxisLabel,
                yAxis: graphObj?.yAxisLabel,
            },
        };
        return outputObj;
    } catch (error) {
        throw error;
    }
};
